import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}
const envData = createSlice({
    name:'envData',
    initialState,
    reducers:{
        addEnvData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default envData.reducer
export const addEnvData = envData.actions.addEnvData